import './polyfills';
import './Home.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { HelmetProvider } from './shims/react-helmet-async';
import { PostHogProvider } from 'posthog-js/react';
import { RootErrorBoundary } from './components/RootErrorBoundary';
import { installChunkLoadRecovery } from './utils/chunkLoadRecovery';
import { installErrorReporter } from './utils/errorReporter';
import posthog, { isPosthogEnabled } from './utils/posthogClient';

installChunkLoadRecovery();
installErrorReporter();

const root = ReactDOM.createRoot(
  document.getElementById('root'));

root.render(
  <React.StrictMode>
    <RootErrorBoundary>
      <HelmetProvider>
        {isPosthogEnabled ? (
          <PostHogProvider client={posthog}>
            <App />
          </PostHogProvider>
        ) : (
          <App />
        )}
      </HelmetProvider>
    </RootErrorBoundary>
  </React.StrictMode>
);
